import React from "react";

function DescriptionField({ className, description }: any) {
  if (description) {
    return <p className={className || "sui-description"}>{description}</p>;
  }
  return null;
}

export default DescriptionField;
